export default "__VITE_ASSET__Bzn8KNGH__"